import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import ChevronRight from "@material-ui/icons/ChevronRight";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ListItem from "@material-ui/core/ListItem";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import AddCommentIcon from "@material-ui/icons/AddComment";
import IconButton from "@material-ui/core/IconButton";

import db, { storage } from "../../../../firebase/firebase";
import CampaignRoom from "./CampaignRoom/CampaignRoom";
import classes from "./CampaignRooms.module.css";
import { selectUser } from "../../../../store/reducers/userSlice";
import AddRoomDialog from "../../../../hooks/Dialogs/AddRoomDialog";

function CampaignRooms() {
  const [channels, setChannels] = useState([]);
  const [collapsed, setCollapsed] = useState(false);
  const user = useSelector(selectUser);
  const [open, setOpen] = useState(false);
  const [chanName, setChanName] = useState("");
  const confirmOpen = open;

  const handleInputChange = (e) => {
    setChanName(e.target.value);
  };
  const toggleModal = () => {
    setOpen(!open);
  };

  useEffect(() => {
    let fetchChannels = db
      .collection("channels")
      .where("channelUsers", "array-contains", user.uid)
      .onSnapshot((snapshot) =>
        setChannels(
          snapshot.docs.map((doc) => ({
            id: doc.id,
            channel: doc.data(),
          }))
        )
      );
    return () => {
      fetchChannels();
    };
  }, [user.uid]);

  const handleAddChannel = () => {
    var storageRef = storage.ref();
    var imagesRef = storageRef.child("/resources/images/rooms/T_Emblem_NoBG_10.png");
    const channelName = chanName;
    if (channelName) {
      imagesRef.getDownloadURL().then((url) => {
        db.collection("channels").add({
          channelName: channelName,
          channelOwner: user.uid,
          channelUsers: [user.uid],
          channelImage: url,
        });
      });
    }
  };

  function toggleCollapse() {
    setCollapsed((prevValue) => !prevValue);
  }

  function onClick(e) {
    toggleCollapse();
  }

  let expandIcon;

  if (!collapsed) {
    expandIcon = (
      <ExpandMoreIcon className={classes.sidebar__item__expand__arrow} />
    );
  } else {
    expandIcon = (
      <ChevronRight className={classes.sidebar__item__expand__arrow} />
    );
  }

  return (
    <>
      <ListItem
        className={classes.sidebar__item}
        onClick={onClick}
        button
        dense
      >
        <div className={classes.sidebar__item__content}>
          <h3 className={classes.sidebar__item__text}>Campaigns</h3>
        </div>
        {expandIcon}
      </ListItem>
      <Collapse in={!collapsed} timeout="auto" unmountOnExit>
        <List>
          {channels.map(({ id, channel }) => (
            <React.Fragment key={id}>
              <CampaignRoom key={id} id={id} channel={channel} />
            </React.Fragment>
          ))}
          {/* <Divider style={{ margin: "10px 0" }} /> */}
          <div className={classes.sidebar__channelsHeader}>
            <IconButton
              size="large"
              className={classes.sidebar__button}
              onClick={() => toggleModal()}
            >
              <AddRoomDialog
                title="Add new campaign room?"
                open={confirmOpen}
                onConfirm={handleAddChannel}
                //trying to store value in state
                onChange={handleInputChange}
              ></AddRoomDialog>
              <AddCommentIcon fontSize="small" color="primary" />
            </IconButton>

            <h4 className={classes.textHover}>New Campaign</h4>
          </div>
        </List>
      </Collapse>
    </>
  );
}

export default CampaignRooms;
